export default [
    {
        name: 'cadastro-estado',
        path: 'estado',
        redirect: 'estado/index',
        component: () => import(/* webpackChunkName: 'cadastro-estado' */ '@/views/cadastro/estado/Index'),
        children: [
            {
                meta: {title: 'Lista de estados'},
                name: 'cadastro-estado-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-estado' */ '@/views/cadastro/estado/List.vue'),
            },
        ],
    },
]